import {
  HttpContextToken,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { TokenProviderService } from '../token-provider/token-provider-service';

export const BYPASS_AUTH = new HttpContextToken<boolean>(() => false);

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  public constructor(private tokenProviderService: TokenProviderService) {}

  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.context.get(BYPASS_AUTH)) {
      return next.handle(req);
    }

    const apiConfig = environment.apiConfig;
    const url = req.url.toLowerCase();
    let scopes: string[] | undefined;

    if (url.startsWith(apiConfig.trackerApiUrl.toLowerCase())) {
      scopes = apiConfig.trackerApiScopes;
    } else if (url.startsWith(apiConfig.fileApiUrl.toLowerCase())) {
      scopes = apiConfig.fileApiScopes;
    } else if (url.startsWith(apiConfig.userApiUrl.toLowerCase())) {
      scopes = apiConfig.userApiScopes;
    } else if (url.startsWith(apiConfig.organizationApiUrl.toLowerCase())) {
      scopes = apiConfig.organizationApiScopes;
    } else if (url.startsWith(apiConfig.projectApiUrl.toLowerCase())) {
      scopes = apiConfig.projectApiScopes;
    } else if (url.startsWith(apiConfig.contractApiUrl.toLowerCase())) {
      scopes = apiConfig.contractApiScopes;
    } else if (url.startsWith(apiConfig.nsInvoiceApiUrl.toLowerCase())) {
      scopes = apiConfig.nsInvoiceApiScopes;
    } else if (url.startsWith(apiConfig.metricApiUrl.toLowerCase())) {
      scopes = apiConfig.metricApiScopes;
    } else if (url.startsWith(apiConfig.vendorApiUrl.toLowerCase())) {
      scopes = apiConfig.vendorApiScopes;
    } else if (url.startsWith(apiConfig.nsClientApiUrl.toLowerCase())) {
      scopes = apiConfig.nsClientApiScopes;
    } else if (url.startsWith(apiConfig.serviceApiUrl.toLowerCase())) {
      scopes = apiConfig.serviceApiScopes;
    } else if (url.startsWith(apiConfig.contractOrchestrationApiUrl.toLowerCase())) {
      scopes = apiConfig.contractOrchestrationApiScopes;
    } else if (url.startsWith(apiConfig.invoiceBillingResolverApiUrl.toLowerCase())) {
      scopes = apiConfig.invoiceBillingResolverApiScopes;
    } else if (url.startsWith(apiConfig.serviceVendorTaxonomyApiUrl.toLowerCase())) {
      scopes = apiConfig.serviceVendorTaxonomyApiScopes;
    } else if (url.startsWith(apiConfig.classificationEngineApiUrl.toLowerCase())) {
      scopes = apiConfig.classificationEngineApiScopes;
    } else if (url.startsWith(apiConfig.documentApiUrl.toLowerCase())) {
      scopes = apiConfig.documentApiScopes;
    }

    if (scopes) {
      return this.tokenProviderService.getAccessTokenForScope(scopes).pipe(
        switchMap((token) => {
          const authReq = req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
            },
          });
          return next.handle(authReq);
        }),
      );
    }
    return next.handle(req);
  }
}
